import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/zelle_deposit';

import Create from './create';
import Confirm from './confirm';
import Notice from './notice';

export default () => {
    const {stage} = useSelector(Selector);

    if(stage === 'create') return <Create />
    if(stage === 'notice') return <Notice />
    if(stage === 'confirm') return <Confirm />
    return <>{stage}</>;
}